import Modal from "components/Modal/Modal";
import styles from './Routing.module.scss';
import ListPractitioners from "./ListPractitioners";
import React from "react";
import CreateRoute from "./CreateRoute";
import { Step, store } from "stores/Store";
import { observer } from "mobx-react-lite";

interface IRoutingModal {
  selectedPractitioners: any[];
  isOpen: boolean;
  handleClose: () => void;  
  onClear: () => void;
}

const RoutingModal = observer(({
  selectedPractitioners,
  isOpen,
  handleClose,
  onClear
}: IRoutingModal) => {

  const [practitioners, setPractitioners] = React.useState<any[]>();

  React.useEffect(() => {
    setPractitioners(selectedPractitioners);
  }, [selectedPractitioners]);

  return (
    <Modal
      handleClose={handleClose}
      isOpen={isOpen}
    >
      <div className={styles.wrapper}>
        {store.routingModalStep === Step.LIST_PRACTITIONERS && (
          <ListPractitioners
            practitioners={practitioners || []}
            setPractitioners={setPractitioners}
            onClear={onClear}
            isOpen={isOpen}
            handleClose={handleClose}
          />
        )}
        {store.routingModalStep === Step.CREATE_ROUTE && (
          <CreateRoute
            waypoints={practitioners || []}
          />
        )}
      </div>
    </Modal>
  )
});

export default RoutingModal;